<a routerLink="/" aria-label="Home Page">Home</a>
<span> › </span>
@for (category of product.categories; track $index) {
<a routerLink="/search" [queryParams]="{category_ids: category.id}"
  >{{category.name}}</a
>
<span> › </span>
}
<span>{{product.name}}</span>
